const API_URL = "https://mern-user-app.herokuapp.com";

export default API_URL;
